export default "__VITE_ASSET__B9ixsp1C__"